import { createContext } from 'react';

import type { LayoutContextValue } from './layout.type';

export const LayoutContext = createContext<LayoutContextValue>({
  layoutType: undefined,
  isTopElementEnabled: false,
  setLayout: () => {},
});
